<template>
  <div
    class="cart__recently-viewed-items pb-sm"
    v-if="recentlyViewedProducts?.length"
  >
    <h2 class="text--center recently-viewed-title mt-0">
      Recently Viewed Items
    </h2>
    <ProductListSlider
      :products="
        recentlyViewedProducts?.length
          ? recentlyViewedProducts
          : placeholderProducts
      "
      @item-click="closeCartPopup"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, Ref, ref } from 'vue'
import useProductStore from '@/store/product'
import Analytics from '@/services/analytics'
import ProductListSlider from '@/components/product/ProductListSlider.vue'
import { Product } from '@/types'
import { useProductRecentlyViewedItems } from '@/pages/product/composables/ProductRecentlyViewed'
import { EVENT_SHOW_CART_POPUP, EVENT_CLOSE_CART_POPUP } from '@/utils'
import EventBus from '@/services/eventbus'

const { saveProductToCache, getRecentlyViewedItems } =
  useProductRecentlyViewedItems()

const productStore = useProductStore()
const recentlyViewedProducts: Ref<Product[] | null> = ref([])
const placeholderProducts = Array(10).fill(undefined)

onMounted(async () => {
  Analytics.excuteOnReady(async () => {
    const userTraits = Analytics.getUserTraits()
    if (userTraits?.recentlyViewedItemsCode?.length) {
      const productsRecentlyViewed =
        await productStore.getProductRecentlyViewed({
          recently_view: userTraits?.recentlyViewedItemsCode,
        })
      if (productsRecentlyViewed?.length) {
        for (let i = productsRecentlyViewed.length - 1; i >= 0; i--) {
          await saveProductToCache(productsRecentlyViewed[i])
        }
      }
      recentlyViewedProducts.value = await getRecentlyViewedItems()
    }
  })

  EventBus.on(EVENT_SHOW_CART_POPUP, getRecentlyViewedProduct)
})

onUnmounted(() => {
  EventBus.off(EVENT_SHOW_CART_POPUP, getRecentlyViewedProduct)
})

async function getRecentlyViewedProduct() {
  recentlyViewedProducts.value = await getRecentlyViewedItems()
}

function closeCartPopup() {
  EventBus.trigger(EVENT_CLOSE_CART_POPUP)
}
</script>

<style lang="scss">
.cart__recently-viewed-items {
  grid-area: d;
  .recently-viewed-title {
    font-size: 20px;
  }
}
.cart-popup {
  .carousel {
    --carousel-slide-width: calc((100% - 1em) / 2 - 1px);
  }
}
</style>
